<template>
    <div>
        <Mainlayout></Mainlayout>
        <CCol sm="12" style="background-size: cover;background:linear-gradient(0deg, #26224E 0%, #26224E 100%), url(<path-to-image>) lightgray 50%">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div style="margin: 5%">
                            <div class="text-center">
                                <br /><br /><br />
                                <h1 class="custom-text-aladdin text-white poppin-font text-48px">
                                    Find answers to the most frequently <br /> asked questions about our services.
                                </h1>
                                <br /><br /><br />
                                <CContainer class="mt-3">
                                    
                                   <input type="text" placeholder="Search....." class="custom-input-app"/>
                                </CContainer>
                                <br /><br /><br />
    
                            </div>
    
    
    
                        </div>
                        <br />
    
                    </CCol>
    
                </CRow>
            </CCol>
        </CCol>
    
     
        <CCol sm="12" class="bg-FAFAFA">
            <CCol sm="8" style="width: 90%;background-size: cover; margin: auto;color: #fff">
                <br /> <br /> <br /> <br /> <br />
                <CCard class="bg-white b-20 m-" style="border:none;">
                <CRow class="m-1">
                    <CCol sm="12">
                        <h3 class="custom-40px-500 text-center mt-3">Frequently asked questions</h3>
                        <p class="custom-18px-400 text-center m-2 font-general-sans">If you have questions that are not listed here, send them to us via email.</p>
                    </CCol>
                    <CCol sm="12">
                        <div style="text-align: left;" class="{ activeclass: isActive }">
                                    <ToggleCard title="What is this AI-Based Public Complaint Reporting System?">
                                        This system is a digital platform that allows the public to submit complaints online using artificial intelligence (AI) technology for more efficient complaint processing and resolution.
                                    </ToggleCard>
    
                                    <ToggleCard title="How do I submit a report through this system?">
               </ToggleCard>
    
                                    <ToggleCard title="Will the report I submit be kept confidential?"></ToggleCard>
    
                                    <ToggleCard title="How long does it take to receive feedback?">
                                      </ToggleCard>
    
                                    <ToggleCard title="What types of complaints can be reported through this system?">
                                    </ToggleCard>
    
                                    <ToggleCard title="Can I submit a complaint anonymously?"></ToggleCard>
                                    
                                        <ToggleCard title="How can I check the status of a report I have submitted?"></ToggleCard>
                                    
                                       
                                </div>
                    </CCol>
                </CRow>
            </CCard>
    
            </CCol>
    
        </CCol>

      
    
        <Footerlayout></Footerlayout>
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import MainlayoutLogin from "../containers/LoginHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";
import ToggleCard from '../components/Toggle.vue';

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        MainlayoutLogin,
        Footerlayout,
        ToggleCard
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrNoArrow,
            Names: "",

        };
    },
    created() {
        AOS.init();
    },
    mounted() {
        // const isAuth = this.UserAuth();
        //     if (isAuth) {
        //     this.GetInfoUser();
        // } else {
        //     this.loading = false; // If not authenticated, immediately set loading to false
        // }
},
methods: {
    async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, { withCredentials: true });
                if (response.status === 200 && response.data) {
                    this.user = response.data;
                    this.Names = this.user.name;
                } else {
                    this.$router.push("Faq");
                    console.error("User info retrieval failed:", response.data.detail);
                }
            } catch (error) {
                this.$router.push("Faq");
                console.error("Error fetching user info:", error);
            }
        },
}

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}
</style>